import { useSelector } from "react-redux";
import { ApplicationState } from "src/store";

export const useSpedDevolutionState = () => {
  const selectSpedDevolutionState = (state: ApplicationState) => state.spedDevolution;
  return useSelector(selectSpedDevolutionState);
};
